import { ApplicationRoles } from '../users/user-roles';

export interface RoleOnboardingCourse {
  id: number;
  role: ApplicationRoles;
  roleName: string;
  title: string;
  videoUrl?: string | null;
  videoFileId?: number | null;
  videoFileName?: string | null;
  /** Resolved external or presigned URL for admin view / open in new tab */
  playableVideoUrl?: string | null;
  description?: string | null;
  isActive: boolean;
  isMandatory: boolean;
  displayOrder: number;
  version: number;
  status: string;
}

export interface CreateRoleOnboardingCourse {
  role: ApplicationRoles | null;
  title: string;
  videoUrl: string;
  videoFileId: number | null;
  description: string;
  isActive: boolean;
  isMandatory: boolean;
  displayOrder: number;
}

export function CreateRoleOnboardingCourseDefaultValues(): CreateRoleOnboardingCourse {
  return {
    role: null,
    title: '',
    videoUrl: '',
    videoFileId: null,
    description: '',
    isActive: true,
    isMandatory: true,
    displayOrder: 1
  };
}

export interface PendingRoleOnboarding {
  id: number;
  role: ApplicationRoles;
  roleName: string;
  title: string;
  videoUrl: string;
  description?: string | null;
  isMandatory: boolean;
}

export interface MyRoleOnboarding extends PendingRoleOnboarding {
  isAcknowledged: boolean;
  acknowledgedOnUtc?: string | null;
}

export interface RoleOnboardingAcknowledgement {
  id: number;
  userName: string;
  email: string;
  role: ApplicationRoles;
  roleName: string;
  acknowledgedOnUtc: string;
  titleSnapshot: string;
  videoUrlSnapshot: string;
  videoDisplayName?: string | null;
  playableVideoUrl?: string | null;
  courseVersion: number;
  acknowledgedFromIp?: string | null;
}

/** Matches BB.Entities.Enums.MaterialType.Video */
export const ROLE_ONBOARDING_VIDEO_MATERIAL_TYPE = 4;
